module.exports = "<template>\n    <div class=\"label\">{{options.label}}</div>\n    <div class=\"icon icon-{{kebabcase options.icon}}\"></div>\n</template>";